import { render, staticRenderFns } from "./MarketSupport.vue?vue&type=template&id=06604139"
import script from "./MarketSupport.vue?vue&type=script&lang=js"
export * from "./MarketSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports